












































































































































































































































































































































































































































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutoCompleteAddress from '@/components/UI/autocomplete-address.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiCepTextField from '@/components/UI/cep-textfield.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiSelectGeoAreas from '@/components/UI/select-geo-area.vue';
import { InstituicaoParmDTO } from '@/interfaces/crm-institution';
import * as service from '@/services/crm-institution';
import * as resize from '@/subjects/resize';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ContactRelationshipTable from '../contact/contact-relationship-table.vue';
import VisitPlanningForm from '../visit-planning/visit-planning-form.vue';
import VisitForm from '../visit/visit-form.vue';
import ClientUnitsExistConfirmDialog from './client-units-exist-confirm-dialog.vue';
import InstitutionPrescrCharts from './institution-prescr-charts.vue';
import InstitutionPrescrDoctorsCharts from './institution-prescr-doctors-charts.vue';

@Component({
  components: {
    UiAutocompleClientsSubsidiaries,
    UiDatePicker,
    UiCepTextField,
    ContactRelationshipTable,
    VisitPlanningForm,
    VisitForm,
    UiAutoCompleteAddress,
    UiSelectGeoAreas,
    ClientUnitsExistConfirmDialog,
    InstitutionPrescrCharts,
    InstitutionPrescrDoctorsCharts
  }
})
export default class InstitutionForm extends BaseComponent {  
  @Prop()
  id: number;

  @Prop({ default: false })
  edit: boolean;

  readonly = false;

  modalOpen = false;
  currentTab = 'tab-dados-base';

  dto: any = {
    prospect: false
  };
  endereco: any = {};
  chkEnderecoGoogle = false;
  enderecoGoogle = null;

  contatos = new Array();

  clientDetails: any = {};
  dataVigenciaContratoHint = null;
  horarioLimitePrescricaoHint = null;
  horarioLimiteEntregaHint = null;

  qualifications = [];
  npSuppliers = [];
  rtus = [];
  patientTypes = [];

  smallScreen: boolean = resize.isXsOrSmSizeScreen();

  canChangeSituation = true;

  showDialogClientsUnitsExist = false;
  clientUnitsCpnj = [];

  loading = false;

  public form: any = {
    valid: false,
    rules: {
      logradouro: [(v) => !!v || 'Informe o logradouro'],
      numero: [(v) => !!v || 'Informe o número'],
      bairro: [(v) => !!v || 'Informe o bairro'],
      cidade: [(v) => !!v || 'Informe a cidade'],
      estado: [(v) => !!v || 'Informe o estado'],
      cep: [(v) => !!v || 'Informe o CEP'],
      obrigatorio: [(v) => v != null || 'Campo obrigatório'],
      horarioLimPrescricao: [(v) => !v || v.length == 5 || 'Informe um horário válido'],
      horarioLimEntrega: [(v) => !v || v.length == 5 || 'Informe um horário válido'],
      areaGeografica: [(v) => this.isGeoAreaValid(v) || 'Informe a Área Geográfica']
    }
  };

  public headersAgendamentos: any = [
    { text: 'Agendado para', value: '', sortable: false },
    { text: 'Usuário alteração', value: '', sortable: false },
    { text: '', value: '', sortable: false, width: '90' }
  ];

  public headersVisitas: any = [
    { text: 'Realizada em', value: '', sortable: false },
    { text: 'Usuário alteração', value: '', sortable: false },
    { text: '', value: '', sortable: false, width: '90' }
  ];

  public $refs!: {
    form: HTMLFormElement;
  };

  @Watch('id', { immediate: true })
  onIdChange() {
    if (!this.id) {
      return;
    }
    this.loading = true;
    this.loader.start('Carregando ...');
    service.getInstitutionDetails(this.id).subscribe(
      (res) => {
        this.loader.stop();
        this.loading = false;
        this.dto = { ...res };
        this.endereco = this.dto.endereco;
        this.contatos = this.dto.contatos;
        this.canChangeSituation = this.dto.usuarioPodeMigrarProspectCliente;
        setTimeout(() => {
          if (this.edit) {
            this.$refs.form.validate();
          }
        }, 1000);
      },
      (error) => {
        this.showToastApiError(error);
        this.close();
      }
    );
  }

  mounted() {
    setTimeout(() => {
      this.modalOpen = true;
    }, 50);

    this.loadQualifications();
    this.loadNpSuppliers();
    this.loadRtus();
    this.loadPatientTypes();
  }

  loadQualifications() {
    service.listInstitutionQualifications().subscribe(
      (res) => {
        this.qualifications = res;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  loadNpSuppliers() {
    service.listInstitutionNpSuppliers().subscribe(
      (res) => {
        this.npSuppliers = res;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  loadRtus() {
    service.listInstitutionRtus().subscribe(
      (res) => {
        this.rtus = res;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  loadPatientTypes() {
    service.listInstitutionPatientTypes().subscribe(
      (res) => {
        this.patientTypes = res;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  onProspectChange(p) {
    if (p === true) {
      Object.entries(this.dto).forEach(([chave, valor]) => {
        this.dto[chave] = null;
      });
      this.dto.prospect = true;
      this.endereco = {};
      this.dto.idUnidade = null;
      this.horarioLimiteEntregaHint = null;
      this.horarioLimitePrescricaoHint = null;
      this.dataVigenciaContratoHint = null;
    }
  }

  onidUnidadeChange() {
    if (!this.canChangeSituation || !this.dto.idUnidade) {
      return;
    }
    this.loadClientUnitDetailsById(this.dto.idUnidade);
  }

  onCnpjChange() {
    if (!this.dto.cnpj) {
      return;
    }
    setTimeout(() => {
      this.loadClientUnitDetailsByCnpj(this.dto.cnpj);
    }, 100);
  }

  loadClientUnitDetailsById(id) {
    this.loader.start('Processando ...');
    service.getInstitutionClientDetails(id).subscribe(
      (res) => {
        this.loader.stop();
        this.prepareClientDetailsResult(res);
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }

  loadClientUnitDetailsByCnpj(cnpj) {
    this.loader.start('Processando ...');
    service.getInstitutionProspectDetails(cnpj).subscribe(
      (res) => {
        this.loader.stop();
        this.prepareClientDetailsResult(res);
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }

  prepareClientDetailsResult(res) {
    this.clientDetails = res;
    let dto = this.dto;
    dto.razaoSocial = res.razaoSocial;
    dto.nomeFantasia = res.nomeFantasia;
    dto.cnpj = res.cnpj;
    dto.ativo = res.ativo;
    this.endereco = { ...res.endereco };

    dto.temContratoVigente = res.temContratoVigente;
    if (!!res.dataVigenciaContrato) {
      this.dataVigenciaContratoHint = `Consta ${res.dataVigenciaContratoFmt} no cadastro do Cliente`;
      dto.dataVigenciaContrato = res.dataVigenciaContrato;
    }

    if (!!res.horarioLimitePrescricao) {
      this.horarioLimitePrescricaoHint = `Consta ${res.horarioLimitePrescricao} como limite no cadastro da Unidade`;
      dto.horarioLimitePrescricao = res.horarioLimitePrescricao;
    }

    if (!!res.horarioLimiteEntrega) {
      this.horarioLimiteEntregaHint = `Consta ${res.horarioLimiteEntrega} como limite no cadastro da Unidade`;
      dto.horarioLimiteEntrega = res.horarioLimiteEntrega;
    }

    if (!!res.unidadesEncontradas && !!res.unidadesEncontradas.length) {
      this.clientUnitsCpnj = res.unidadesEncontradas;
      this.doShowDialogClientsUnitsExists();
    }
  }

  public close(): void {
    this.$emit('close');
  }

  public save() {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    this.loader.start('Processando ...');

    let parm: InstituicaoParmDTO = Object.assign(new InstituicaoParmDTO(), this.dto);
    parm.endereco = { ...this.endereco };
    if (this.contatos) {
      let contatos: any = Array.from(this.contatos);
      parm.idsContatos = contatos.map((c) => c.id);
    }
    let obs = null;
    if (this.id) {
      obs = service.updateInstitution(parm);
    } else {
      obs = service.saveInstitution(parm);
    }

    obs.subscribe(
      (res) => {
        this.toast.show('Instituição salva com sucesso', 'success');
        this.$emit('afterSave');
        this.loader.stop();
      },
      (error) => {
        this.showToastApiError(error);
        this.loader.stop();
      }
    );
  }

  onCepResult(end) {
    if (!end) {
      return;
    }
    this.endereco = { ...this.endereco, ...end };
  }

  visitPlanningFormOpen = false;
  idVisitPlanningSelected = null;
  visitPlanningEdit = false;

  newVisitPlanning() {
    this.idVisitPlanningSelected = null;
    this.visitPlanningFormOpen = true;
    this.visitPlanningEdit = true;
  }

  openVisitPlanningItem(item, edit) {
    this.idVisitPlanningSelected = item.id;
    this.visitPlanningFormOpen = true;
    this.visitPlanningEdit = edit;
  }

  onCloseVisitPlanningForm() {
    this.visitPlanningFormOpen = false;
  }

  onAfterSaveVisitPlanningForm() {
    this.visitPlanningFormOpen = false;
    service.getInstitutionDetails(this.id).subscribe((res) => {
      this.dto.agendamentos = res.agendamentos;
    });
  }

  visitFormOpen = false;
  idVisitSelected = null;
  visitEdit = false;

  newVisit() {
    this.idVisitSelected = null;
    this.visitFormOpen = true;
    this.visitEdit = true;
  }

  openVisitItem(item, edit) {
    this.idVisitSelected = item.id;
    this.visitFormOpen = true;
    this.visitEdit = edit;
  }

  onCloseVisitForm() {
    this.visitFormOpen = false;
  }

  onAfterSaveVisitForm() {
    this.visitFormOpen = false;
    service.getInstitutionDetails(this.id).subscribe((res) => {
      this.dto.visitas = res.visitas;
    });
  }

  @Watch('enderecoGoogle')
  onEnderecoGoogleChange(e) {
    if (!e) {
      return;
    }
    this.endereco = e;
  }

  isGeoAreaValid(v) {
    return !this.dto.usuarioPodeAlterarArea || !!v;
  }

  onChangeGeoArea(v) {
    if (!v) {
      return;
    }
    if (this.dto.status == 'B' && this.dto.usuarioPodeBloquear) {
      this.dto.status = 'A';
    }
  }

  doShowDialogClientsUnitsExists() {
    this.showDialogClientsUnitsExist = true;
  }

  onDialogSelectClientUnit(selected) {
    this.showDialogClientsUnitsExist = false;
    if (selected && !!selected.id) {
      this.dto.prospect = false;
      this.dto.idUnidade = selected.id;
    }
  }
}
